module.exports = "#white-box{content:\"\";height:100%;width:100%;background:white;z-index:7;position:absolute;top:0;left:0}\n"